import styled from "styled-components";
import { alpha, styled as muiStyled } from "@mui/system";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

const ODD_OPACITY = 0.2;

const DataTableDivContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: ${(props) => (props && props.height) || "90vh"};
  padding-left: 30px;
  padding-right: 16px;
`;

const StyledDataGrid = muiStyled(
  DataGrid,
  {}
)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
  "& .MuiDataGrid-columnSeparator": {
    visibility: "hidden",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal",
    lineHeight: "normal",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#354A55",
    color: "#fff",
    "& .MuiCheckbox-root": {
      color: "#fff",
    },
    "& .MuiButtonBase-root": {
      color: "#fff",
    },
    maxHeight: "168px !important",
  },
  "& .MuiDataGrid-columnHeader": {
    // Forced to use important since overriding inline styles
    height: "unset !important",
  },
  "&.MuiDataGrid-root": {
    border: "0px",
  },
  "& .MuiDataGrid-main": {
    boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
  },
  "& .MuiTablePagination-displayedRows": {
    margin: "unset",
  },
  "& .MuiTablePagination-selectLabel": {
    visibility: "hidden",
  },
}));

export { StyledDataGrid, DataTableDivContainer };
